import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import LoginButton from "@/ComponentsChild/LoginButton.vue";
    import LogoutButton from "@/ComponentsChild/LogoutButton.vue";
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    import { computed, watch } from "vue";
    import { useRouter } from 'vue-router';
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AuthenticationButton',
  setup(__props) {

    const auth0: Auth0 | null = useAuth0();
    const router = useRouter();

    const isAuthenticated = computed(() => {
        if (!auth0) {
            return null;
        }

        return auth0.isAuthenticated.value;
    });

    // Watch the isAuthenticated property and redirect if it changes to true
    watch(isAuthenticated, (newValue) => {
        if (newValue) {
            router.push({ name: 'home' }); 
        }
    });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isAuthenticated.value)
      ? (_openBlock(), _createBlock(LogoutButton, { key: 0 }))
      : (_openBlock(), _createBlock(LoginButton, { key: 1 }))
  ]))
}
}

})